import BaseTemplate from "../templates/BaseTemplate";

const Dashboard = ({ children }) => {
  return (
      <BaseTemplate content={children} title={"Shifts"}/>
  );
};

export default Dashboard;
